import type { ComponentProps } from 'react'
import type { Locale } from '~/lib/i18n/shared'
import type { FileRouteTypes } from '~/routeTree.gen'
import { Link, useParams } from '@tanstack/react-router'
import {
  footballCoreLocale,
  resolveFootballCoreRouteTo,
} from '~/lib/navigation/football-core'

type AllTo = FileRouteTypes['to']
type StripLocalePrefix<T extends string> = T extends '/$locale' ? '/' : T extends `/$locale${infer Rest}` ? Rest : T
export type LocalizedTo = StripLocalePrefix<AllTo> | (string & {})

type LinkProps = ComponentProps<typeof Link>
interface LocalizedLinkProps extends Omit<LinkProps, 'to' | 'params'> {
  to: LocalizedTo
  params?: Record<string, any>
}

export function resolveLocalizedTo(to: LocalizedTo, locale?: Locale | string | null): string {
  return resolveFootballCoreRouteTo(to as string, locale)
}

export function LocalizedLink({ to, params, ...props }: LocalizedLinkProps) {
  const routeParams = useParams({ strict: false })
  const locale = footballCoreLocale(routeParams.locale as string | undefined)

  const fullPath = resolveLocalizedTo(to, locale)

  const needsLocaleParam = fullPath.includes('$locale')
  const finalParams = {
    ...(params || {}),
    ...(needsLocaleParam && locale === 'zh-CN' ? { locale } : {}),
  }

  return <Link {...(props as any)} to={fullPath as any} params={finalParams as any} />
}
